import React from "react";

type InformationAlertProps = {
    children: React.ReactNode;
};

function InformationAlert({ children }: InformationAlertProps) {
    return <div className="alert alert-info">{children}</div>;
}

export default InformationAlert;
